import { type TokenDefinitionWithSingleFee, lookupContract, TokenDefinition, isTokenDefinitionWithSingleFee, } from "@bracket/addressbook";
import CONFIG from "./IEscrowRouter.json";
import { getChainId, raise, getAmount, serializeContract, } from "../helpers";
import type { ContractConfig, } from "../types";


export declare type swapUniswapAndDepositProps = {

	/** the token we are swqapping into */
	token: TokenDefinition;

	/** the token we are swqapping FROM - WETH | ETH -- default is WETH */
	source: TokenDefinition;

	/** the amount we are swapping in the source token value, the amount we are sending */
	amount: number;

	/**  the amount we are swapping in the target token value, the amount we need to receive*/
	minAmount: number;

	slippage?: number;

	fee: number;

}



/**
 * @summary when wrapped_ether_amount is provided the swap will originate from WETH, transferring to the token outherwise the swap will originate from ETH.
 * @param {"ETH" | "wETH"} target_token the label or symbol of the target token 
 * @param {number} ether_amount the amount of ETH
 * @param {number} slippage
 * @returns {ContractConfig} the contract in a shape usable for wagmi.
 */
export const swapUniswapAndDeposit = ({
	token,
	amount,
	source,
	minAmount,
	fee,
	slippage = 0.1,
}: swapUniswapAndDepositProps ): ContractConfig => {

	const chain = getChainId();
	const address = lookupContract(chain, "EscrowRouter");
	const minAmountWithSlippage = amount - ( amount * slippage );

	let result;

	switch( source.label ) {

		case "ETH":
			// console.log("swapUniswapAndDeposit -- elected eth");
			// console.log("amount", amount);
			// console.log("minAmount", minAmount);
			// console.log("minAmountWSlippage", minAmountWithSlippage);

			result = {
				address,
				abi: CONFIG.abi,
				functionName: "swapUniswapAndDeposit",
				args: [
					token.address,
					getAmount(token, minAmountWithSlippage),
					fee,
				],
				value: getAmount(token, minAmount)
			}
	
			const log = [
				"--- ETH SWAP ---",
				`currency: ${token.label}`,
				`contract address: ${result.address}`,
				`functionName: ${result.functionName}`,
				`args:`,
				`\t0 [token address]: ${result.args[0]}`,
				`\t1 [quote+quote*slippage] ${result.args[1].toString()} (${Number(result.args[1]) / Number(1e18)}${token.label})`,
				`\t2 [fee] ${result.args[2]}`,
				`value: ${result.value} (${Number(result.value) / Number(1e18)}ETH)`,
				"----------",
			];
			// console.log(log.join("\n"));
			break;

		case "wETH":

			result = {
				address,
				abi: CONFIG.abi,
				functionName: "swapUniswapAndDeposit",
				args: [
					token.address,
					getAmount(token, minAmount),
					getAmount(token, minAmountWithSlippage),
					fee,
				],
			}
			const wlog = [
				"--- WETH SWAP ---",
				`currency: ${token.label}`,
				`contract address: ${result.address}`,
				`functionName: ${result.functionName}`,
				`args:`,
				`\t0 [token address]: ${result.args[0]}`,
				`\t1 [amount] ${result.args[1].toString()} (${Number(result.args[1]) / Number(1e18)}WETH)`,
				`\t2 [minamount with slippage] ${result.args[2].toString()} (${Number(result.args[2]) / Number(1e18)}${token.symbol})`,
				`\t3 [fee] ${result.args[3]}`,
				"----------",
			];
			// console.log(wlog.join("\n"));
			break;

		default:
			return raise(`IEscrowRouter::swapUniswapAndDeposit failed to gain a valid token for "${name}" on chain ${chain} - must be "WETH" or "ETH"`);

	}

	return result;
}
	// return raise(`IEscrowRouter::swapUniswapAndDeposit failed to gain a valid token for "${name}" on chain ${chain} - must be "WETH" or "ETH"`);
// }


/**
 * @param {AnyValidToken} token the label or symbol of the target token 
 * @param {number} amount the amount of ETH 
 * @returns {ContractConfig} the contract in a shape usable for wagmi.
 */
export const uniswapQuote = (
	token: TokenDefinitionWithSingleFee,
	amount: number,
): ContractConfig => {
	const chain = getChainId();
	if( token ) {
		if( isTokenDefinitionWithSingleFee(token) ) {

			const result = { 
				address: lookupContract(chain, "EscrowRouter"),
				abi: CONFIG.abi,
				functionName: "uniswapQuote",
				args: [
					token.address,
					getAmount(token, amount),
					token.fee,
				],
				chainId: chain,
			};

			const log = [
				"--- ETH QUOTE ---",
				`currency: ${token.label}`,
				`contract address: ${result.address}`,
				`functionName: ${result.functionName}`,
				`args:`,
				`\t0 [token address]: ${result.args[0]}`,
				`\t1 [amount] ${result.args[1].toString()} (${Number(result.args[1]) / Number(1e18)}ETH/WETH)`,
				`\t2 [fee] ${result.args[2]}`,
				"----------",
			];
			// console.log(log.join("\n"));
			return result;
		}
		return raise(`IEScrowRouter::uniswapQuote was invoked without a token definition on a single fee`);
	}
	return raise(`IEscrowRouter::uniswapQuote failed to gain a valid token for "${name}" on chain ${chain}`);
}
